export enum EsRequestsOperationsEnum {
    ENERGY = "ENERGY",
    SERVICES = "SERVICES",
    BENEFITS = "BENEFITS",
    EDPHEALTH = "EDPHEALTH",
    GENERAL = "GENERAL",
}
export enum EsRequestsOperationsDetailEnum {
    CLIENTPENDING = "pt.edponline.request.operations.es.status.clientpending",
    PENDING = "pt.edponline.request.operations.es.status.pending",
    CLOSED = "pt.edponline.request.operations.es.status.closed",
    CANCELLED = "pt.edponline.request.operations.es.status.cancelled",
    RESOLVED = "pt.edponline.request.operations.es.status.resolved",
    PENDING_EDP = "pt.edponline.request.operations.es.status.pendingedp",
    INPROCESS = "pt.edp.edponline.request.operations.es.in.process",
    INCONTRACT = "pt.edp.edponline.request.operations.es.in.contract",
}
